import React from "react";
import {
  Box,
  Typography,
  Card,
  Grid,
  Stack,
  IconButton,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const instructors = [
  {
    name: "Brooklyn Simmons",
    desc: "Learn the art of calm breathing and mindfulness to find inner balance every day.",
    img: "/images/inst1.jpg",
  },
  {
    name: "Leslie Alexander",
    desc: "Experience yoga and meditation that transforms your energy and mental clarity.",
    img: "/images/inst2.jpg",
  },
  {
    name: "Ronald Richards",
    desc: "Guiding students through mindful postures to enhance flexibility and inner strength.",
    img: "/images/inst3.webp",
  },
   {
    name: "Shreya",
    desc: "Guiding students through mindful postures to enhance flexibility and inner strength.",
    img: "/images/inst4.webp",
  },
];

const MeetInstructors = () => {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 8 },
        bgcolor: "#fff",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" },
          flexDirection: { xs: "column", md: "row" },
          mb: 8,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            
            color: "#111",
            mb: { xs: 2, md: 0 },
          }}
        >
          Meet Expert Instructor
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#666",
            maxWidth: 400,
            lineHeight: 1.6,
            textAlign: { xs: "left", md: "right" },
          }}
        >
          It’s a way of life. Whether you’re a beginner or an experienced yogi,
          our welcoming community is here to support you.
        </Typography>
      </Box>

      {/* Instructor Cards */}
      <Grid container spacing={4}>
        {instructors.map((inst, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                borderRadius: "20px",
                position: "relative",
                overflow: "hidden",
                height: 400,
                width:320,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                boxShadow: "0px 6px 20px rgba(0,0,0,0.15)",
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                },
              }}
            >
              {/* Image Background with Gradient */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: `
                    linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0.1)),
                    url(${inst.img})
                  `,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  zIndex: 0,
                }}
              />

              {/* Social Icons (Visible on hover) */}
              <Stack
                direction="column"
                spacing={1}
                sx={{
                  position: "absolute",
                  top: 20,
                  right: 20,
                  opacity: 0,
                  transition: "opacity 0.3s ease",
                  "&:hover": { opacity: 1 },
                  zIndex: 3,
                }}
              >
                <IconButton
                  sx={{
                    bgcolor: "rgba(255,255,255,0.8)",
                    "&:hover": { bgcolor: "rgba(255,255,255,1)" },
                    width: 36,
                    height: 36,
                  }}
                >
                  <FacebookIcon sx={{ color: "#000" }} />
                </IconButton>
                <IconButton
                  sx={{
                    bgcolor: "rgba(255,255,255,0.8)",
                    "&:hover": { bgcolor: "rgba(255,255,255,1)" },
                    width: 36,
                    height: 36,
                  }}
                >
                  <TwitterIcon sx={{ color: "#000" }} />
                </IconButton>
                <IconButton
                  sx={{
                    bgcolor: "rgba(255,255,255,0.8)",
                    "&:hover": { bgcolor: "rgba(255,255,255,1)" },
                    width: 36,
                    height: 36,
                  }}
                >
                  <LinkedInIcon sx={{ color: "#000" }} />
                </IconButton>
              </Stack>

              {/* Glass Effect Content */}
              <Box
                sx={{
                  position: "relative",
                  zIndex: 2,
                  textAlign:"start",
                  bgcolor: "rgba(255,255,255,0.15)",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                  color: "#fff",
               
                  borderRadius: "0 0 20px 20px",
                  p: 2,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: "#fff", mb: 0.5 }}
                >
                  {inst.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "rgba(255,255,255,0.85)", lineHeight: 1.6 }}
                >
                  {inst.desc}
                </Typography>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MeetInstructors;
